"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getNftKey = exports.nftsByCollections = exports.nftsFromOperations = void 0;
var eip55_1 = __importDefault(require("eip55"));
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var _1 = require(".");
var nftsFromOperations = function (ops) {
    var nftsMap = ops
        // if ops are Operations get the prop nftOperations, else ops are considered nftOperations already
        .flatMap(function (op) { var _a; return (((_a = op === null || op === void 0 ? void 0 : op.nftOperations) === null || _a === void 0 ? void 0 : _a.length) ? op.nftOperations : op); })
        .reduce(function (acc, nftOp) {
        var contract = nftOp.contract;
        if (!contract) {
            return acc;
        }
        // Creating a "token for a contract" unique key
        contract = eip55_1["default"].encode(contract);
        var tokenId = nftOp.tokenId, standard = nftOp.standard, accountId = nftOp.accountId;
        if (!tokenId || !standard)
            return acc;
        var id = (0, _1.encodeNftId)(accountId, contract, tokenId || "");
        var nft = (acc[id] || {
            id: id,
            tokenId: tokenId,
            amount: new bignumber_js_1["default"](0),
            collection: { contract: contract, standard: standard }
        });
        if (nftOp.type === "NFT_IN") {
            nft.amount = nft.amount.plus(nftOp.value);
        }
        else if (nftOp.type === "NFT_OUT") {
            nft.amount = nft.amount.minus(nftOp.value);
        }
        acc[id] = nft;
        return acc;
    }, {});
    return Object.values(nftsMap);
};
exports.nftsFromOperations = nftsFromOperations;
var nftsByCollections = function (nfts, collectionAddress) {
    if (nfts === void 0) { nfts = []; }
    var filteredNfts = collectionAddress
        ? nfts.filter(function (n) { return n.collection.contract === collectionAddress; })
        : nfts;
    var collectionMap = filteredNfts.reduce(function (acc, nft) {
        var collection = nft.collection, nftWithoutCollection = __rest(nft, ["collection"]);
        if (!acc[collection.contract]) {
            acc[collection.contract] = __assign(__assign({}, collection), { nfts: [] });
        }
        acc[collection.contract].nfts.push(nftWithoutCollection);
        return acc;
    }, {});
    return Object.values(collectionMap);
};
exports.nftsByCollections = nftsByCollections;
var getNftKey = function (contract, tokenId) {
    return "".concat(contract, "-").concat(tokenId);
};
exports.getNftKey = getNftKey;
//# sourceMappingURL=helpers.js.map